import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './confirm-button.component.html',
  styleUrl: './confirm-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmButtonComponent {
  @Output() readonly onConfirmClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onConfirmClicked.emit();
  }
}
